import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {ArrowLeftSmall, ArrowRightSmall} from '@wix/wix-ui-icons-common'
import {useEnvironment, useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {Text, TextButton} from 'wix-ui-tpa/cssVars'
import {useCurrencyFormatter} from '../../../../../../../commons/hooks/currency'
import {SlideInModal} from '../../slide-in-modal'
import {classes} from './accessibility-mode.st.css'
import {Filters} from './filters'
import {Footer} from './footer'
import {Header} from './header'
import {TicketsCountInfo} from './tickets-count-info'
import {TicketsList} from './tickets-list'
import {AccessibilityModeProps} from './index'

export const AccessibilityMode = ({
  showAccessibilityMode,
  setShowAccessibilityMode,
  onFooterButtonClick,
  placesCount,
  setForcedPopoverPlanPlaceId,
  chooseSeatMode,
  chooseMultipleSeatsMode,
  setAccessibilityToast,
  inDescription,
  inBasket,
}: AccessibilityModeProps) => {
  const {isMobile, isRTL} = useEnvironment()
  const {t} = useTranslation()
  const {getTicketPriceText, getFormattedMoney} = useCurrencyFormatter()

  const {experiments} = useExperiments()
  const planTicketsDesignEnabled = experiments.enabled(ExperimentNames.PlanTicketsDesign)

  const onBackClick = () => {
    setAccessibilityToast?.(false)
    setShowAccessibilityMode(false)
  }

  if (isMobile) {
    return (
      <>
        <div className={classes.mobileContainer} data-hook={DH.SEATING_ACCESSIBILITY_MODE}>
          {planTicketsDesignEnabled && !inBasket && !inDescription ? (
            <>
              <div className={classes.backButtonContainer}>
                <TextButton prefixIcon={isRTL ? <ArrowRightSmall /> : <ArrowLeftSmall />} onClick={onBackClick}>
                  {t('seatings_backToMap_v2')}
                </TextButton>
              </div>
              <Text className={classes.title} tagName="h2">
                {t('seatingMapModal_listTab_title')}
              </Text>
            </>
          ) : null}
          <Filters t={t} getFormattedMoney={getFormattedMoney} getTicketPriceText={getTicketPriceText} />
          {placesCount ? <TicketsCountInfo placesCount={placesCount} /> : null}
          <TicketsList showAccessibilityMode={true} />
        </div>
        <Footer onButtonClick={onFooterButtonClick} />
      </>
    )
  }

  return (
    <SlideInModal
      id="accessibility-mode"
      dataHook={DH.SEATING_ACCESSIBILITY_MODE}
      show={showAccessibilityMode}
      backButtonText={t('seatings_closeTicketList')}
      onBackClick={onBackClick}
    >
      <Header />
      <Filters t={t} getFormattedMoney={getFormattedMoney} getTicketPriceText={getTicketPriceText} />
      {placesCount ? <TicketsCountInfo placesCount={placesCount} /> : null}
      <TicketsList setForcedPopoverPlanPlaceId={setForcedPopoverPlanPlaceId} showAccessibilityMode={true} />
      {!chooseSeatMode && !chooseMultipleSeatsMode ? <Footer /> : null}
    </SlideInModal>
  )
}
